import {
  NOTIFICATIONS_LIST,
  NOTIFICATIONS_LIST_SUCCESS,
  NOTIFICATIONS_LIST_ERROR,
  NOTIFICATIONS_NEW,
  NOTIFICATIONS_NEW_SUCCESS,
  NOTIFICATIONS_NEW_ERROR,
  NOTIFICATIONS_USER_LIST,
  NOTIFICATIONS_USER_LIST_SUCCESS,
  NOTIFICATIONS_USER_LIST_ERROR,
  NOTIFICATIONS_GROUP_LIST,
  NOTIFICATIONS_GROUP_LIST_SUCCESS,
  NOTIFICATIONS_GROUP_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseUserList: "",
  loadingUserList: false,
  errorUserList: "",
  responseGroupList: "",
  loadingGroupList: false,
  errorGroupList: "",
}

const Notifications = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATIONS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case NOTIFICATIONS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case NOTIFICATIONS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case NOTIFICATIONS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: "",
        responseUserList: "",
        errorUserList: "",
      }
      break
    case NOTIFICATIONS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case NOTIFICATIONS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case NOTIFICATIONS_USER_LIST:
      state = {
        ...state,
        responseUserList: "",
        loadingUserList: true,
        errorUserList: "",
        responseNew: "",
      }
      break
    case NOTIFICATIONS_USER_LIST_SUCCESS:
      state = {
        ...state,
        loadingUserList: false,
        responseUserList: action.payload.data,
      }
      break
    case NOTIFICATIONS_USER_LIST_ERROR:
      state = {
        ...state,
        loadingUserList: false,
        errorUserList: action.payload,
      }
      break
    case NOTIFICATIONS_GROUP_LIST:
      state = {
        ...state,
        responseGroupList: "",
        loadingGroupList: true,
        errorGroupList: "",
        responseNew: "",
      }
      break
    case NOTIFICATIONS_GROUP_LIST_SUCCESS:
      state = {
        ...state,
        loadingGroupList: false,
        responseGroupList: action.payload.data,
      }
      break
    case NOTIFICATIONS_GROUP_LIST_ERROR:
      state = {
        ...state,
        loadingGroupList: false,
        errorGroupList: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}
export default Notifications